import { render, staticRenderFns } from "./parked-call.vue?vue&type=template&id=3847bf28&"
import script from "./parked-call.vue?vue&type=script&lang=js&"
export * from "./parked-call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports